import React, { useState } from 'react';
import down from '@/public/svg/chevrondown.svg';
import up from '@/public/svg/chevronup.svg';

interface FaqItem {
    question: string;
    answer: string;
}

interface FaqAccordionProps {
    icon: string;
    title: string;
    faqs: FaqItem[];
}

const FaqAccordion: React.FC<FaqAccordionProps> = ({ icon, title, faqs }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="max-w-3xl mx-auto w-full py-4">
            <div className="flex items-start gap-2">
                <img src={icon} alt="Icon" loading="lazy" className="w-5 h-5 mt-1" />
                <h2 className="text-2xl text-textColor font-bold mb-4">{title}</h2>
            </div>

            {faqs.map((faq, index) => (
                <div
                    key={index}
                    className="border-b border-gray-200 py-4"
                >
                    <button
                        onClick={() => toggle(index)}
                        className="w-full text-left flex justify-between items-center text-lg font-medium text-textColor focus:outline-none"
                    >
                        <span>{faq.question}</span>
                        <span className="text-secondary">{openIndex === index ? <img className='h-4' src={up} /> : <img className='h-2' src={down} />}</span>
                    </button>

                    {openIndex === index && (
                        <div
                            className="mt-2 text-md text-textColor space-y-2"
                            dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                    )}

                </div>
            ))}
        </div>
    );
};

export default FaqAccordion;
